<template lang="pug">
iframe.rounded(
  ref="player"
  :src="embedLink"
  :width="videoWidth"
  :height="iframeHeight"
  allow="autoplay"
  frameborder="0"
  allowscriptaccess="always"
)
</template>

<script>
export default {
  props: {
    src: { type: String, required: true, default: '' },
    videoWidth: { type: String, default: '100%' },
  },
  data() {
    return {
      iframeHeight: 0,
      embedLink: '',
      isVisible: true,
    };
  },
  watch: {
    src(v) {
      this.embedLink = this.prepareLink(v);
    },
    isVisible(v) {
      this.videoStateHandler(v);
    },
  },
  mounted() {
    this.embedLink = this.prepareLink(this.src);
    const iframe = this.$refs.player;
    this.iframeHeight = iframe.clientWidth * 0.55;
    window.addEventListener('resize', () => {
      this.iframeHeight = iframe.clientWidth * 0.55;
    });
    const element = document.querySelector('.custom-application--wrap');
    if (element) element.addEventListener('scroll', this.scrollHandler);
    this.videoStateHandler(this.isIframeVisible());
  },
  beforeDestroy() {
    const element = document.querySelector('.custom-application--wrap');
    if (element) element.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    prepareLink(rawData) {
      return `${rawData}?autoplay=1&mute=1&enablejsapi=1&loop=1`;
    },
    scrollHandler() {
      this.videoStateHandler(this.isIframeVisible());
    },
    videoStateHandler(isVisible) {
      const { hostname } = new URL(this.src);
      const lowerHostname = hostname.toLowerCase();
      let params = {};
      if (lowerHostname.includes('youtube')) {
        params = {
          event: 'command',
          func: isVisible ? 'playVideo' : 'pauseVideo',
        };
      } else if (lowerHostname.includes('rutube')) {
        params = {
          type: isVisible ? 'player:play' : 'player:pause',
          data: {},
        };
      } else if (lowerHostname.includes('dzen')) {
        params = {
          method: isVisible ? 'play' : 'pause',
        };
      } else {
        return false;
      }
      this.$refs.player.contentWindow.postMessage(JSON.stringify(params), '*');
      return true;
    },
    isIframeVisible() {
      const iframe = this.$refs.player;
      const targetPosition = {
        top: window.pageYOffset + iframe.getBoundingClientRect().top,
        bottom: window.pageYOffset + iframe.getBoundingClientRect().bottom,
      };
      const windowPosition = {
        top: window.pageYOffset,
        bottom: window.pageYOffset + document.documentElement.clientHeight,
      };
      if (
        targetPosition.bottom > windowPosition.top
        && targetPosition.top < windowPosition.bottom
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
